import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BottomBar() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/menu-items/bottom-menu`)
      .then(r => r.json())
      .then(setItems)
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <footer className="bottombar">
      {items.map(item => (
        <a key={item.code} href={`/content/${item.code}`}>
          {item.menuTitle || item.title}
        </a>
      ))}
    </footer>
  );
}
